var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefreshBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8535 8.7927L18.9995 7.646L19.7075 8.353L17.3535 10.707L14.9995 8.353L15.7075 7.646L16.8535 8.7927V8.5C16.8535 4.64 13.7135 1.5 9.8535 1.5C7.9835 1.5 6.2255 2.228 4.9035 3.55L4.1965 2.843C5.7075 1.332 7.7165 0.5 9.8535 0.5C14.2645 0.5 17.8535 4.089 17.8535 8.5V8.7927ZM4 9.3535L2.8535 8.207V8.5C2.8535 12.36 5.9935 15.5 9.8535 15.5C11.7235 15.5 13.4815 14.772 14.8035 13.45L15.5105 14.157C13.9995 15.668 11.9905 16.5 9.8535 16.5C5.4425 16.5 1.8535 12.911 1.8535 8.5V8.2077L0.707 9.3535L0 8.6465L2.354 6.2925L4.707 8.6465L4 9.3535Z",
    fill: "#2C2A29"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefreshBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refreshBlack.19428f83109a7eb37b3cbcd285ec98a5.svg";